export default {
   'features': 'विशेषताएँ',
   'downloads': 'डाउनलोड',
   'roadmap': 'रोडमैप',
   'price': 'कीमत',
   'donate': 'दान करें',
   'feedback': 'प्रतिक्रिया',
   'panel': 'नियंत्रण पट्टिका',
};
